import React from "react";
import Header from "../components/Header";
import { HeroImgServices, ServicesContent } from "../components/ServicesComp";
import Footer from "../components/Footer";

const Services = () => {
  return (
    <>
    <title>Services</title>
    <meta
      name="description"
      content="dfgdfgdfgdfgdfgdfg"
    />      <Header />
      <HeroImgServices />
      <ServicesContent />
      <Footer />
    </>
  );
};

export default Services;
